import * as React from 'react';
import {Field, reduxForm, InjectedFormProps} from 'redux-form';
import {RenderField, CarIdsSelect, Validators} from './Fields/_Fields';
import {WithTranslation, withTranslation} from 'react-i18next';
import * as VehiclesModule from 'Modules/VehiclesModule';
import {connect} from 'react-redux';
import {ErrorStore} from 'Redux/Actions/Models/ErrorActionModel';
import {compose} from 'redux';
import {cacheFormValues, resetCacheFormValues} from "Redux/Actions/FleetActions";
import {IManageFleetFormValues} from "Models/FleetModel";
import {RootState} from "Redux/Reducers/_RootReducer";
import {OptionsElement} from "Models/ViewManagementModel";
import * as UserModule from "Modules/UserModule";
import AutoCompleteField from "components/Layout/Form/Fields/AutoCompleteField";
import type { AsyncPaginateProps } from 'react-select-async-paginate';

interface IProps {
  fetchUsers: AsyncPaginateProps<OptionsElement>['loadOptions']
}

interface IMappedStateToProps {
  errorStore: ErrorStore
  activeUserRole: UserModule.Types.UserDto['roleName']
}

interface IMappedDispatchToProps {
  cacheFormValues: (formValues: IManageFleetFormValues) => void
}

interface IManageFleetForm {
  onCancel: Function
  onDelete: Function
  onFleetDelete: Function
  redirect: Function
  initialCars: VehiclesModule.Types.CarDto[]
  showVehicleList: () => void
}

type Props =
  & IProps
  & InjectedFormProps
  & WithTranslation
  & IManageFleetForm
  & IMappedDispatchToProps
  & IMappedStateToProps

const AddFleet = (props: Props) => {
  const {
    handleSubmit,
    t,
    initialCars,
    onDelete,
    showVehicleList,
    activeUserRole,
    fetchUsers,
  } = props;

  return (
    <form className="form form--flex form--medium" onSubmit={handleSubmit}>
      <div className="form__col form__col--ratio-1">
        <Field
          name="name"
          component={RenderField}
          type="text"
          placeholder={t('fleetName')}
          label={t('fleetName')}
          validate={[Validators.required]}
        />
        {activeUserRole === UserModule.UserEnumTypes.RoleName.ADMIN && (
          <Field
            name="fleetOwner"
            component={AutoCompleteField}
            type="text"
            placeholder={t('FLEET_OWNER')}
            noOptionsMessage={() => t('noOptions')}
            label={t('FLEET_OWNER')}
            validate={[Validators.required]}
            fetchOptions={fetchUsers}
          />
        )}
      </div>
      <div className="form__col form__col--ratio-2 ml-50">
        <Field
          onDelete={onDelete}
          name="carIds"
          component={CarIdsSelect}
          type="text"
          placeholder={t('assignedCars')}
          label={`${t('assignedCars')} ${initialCars ? initialCars.length : ''}`}
          validate={[Validators.required]}
          showList={showVehicleList}
        />
      </div>
    </form>
  );
};

function mapStateToProps(state: RootState): IMappedStateToProps {
  return {
    errorStore: state.errorStore,
    activeUserRole: state.userStore.user.roleName,
  };
}

export default compose(
  connect(mapStateToProps),
  withTranslation(['forms', 'errors', 'carDetails']),
  reduxForm<IManageFleetFormValues>({
    form: 'AddFleet',
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
    onSubmitSuccess(_, dispatch) {
      dispatch(resetCacheFormValues())
    },
    onChange(values, dispatch) {
      dispatch(cacheFormValues(values))
    }
  })
)(AddFleet) as React.ComponentClass<any>



// WEBPACK FOOTER //
// ./src/components/Layout/Form/AddFleet.tsx